import Grid from '$components/layout/Grid';
import MainTitle from '$layout/partials/MainTitle';
import { Styled } from './styled';

const { Col } = Grid;

export interface PageTitleProps {
  readonly pageTitle: string;
}

export function PageTitle({ pageTitle }: PageTitleProps): JSX.Element {
  return (
    <Styled className="TeamSupport__pageTitle">
      <Col span={12}>
        <MainTitle>{pageTitle}</MainTitle>
      </Col>
    </Styled>
  );
}

PageTitle.displayName = 'PageTitle';
